import Logo4 from "images/partners/turku.svg"
import LogoAbo from "images/partners/turku-sv.svg"
import Logo5 from "images/partners/pelastakaa-lapset-sv-fi.svg"
import Logo7 from "images/partners/vantaa.svg"
import Logo8 from "images/partners/tampere.svg"
import LogoVanda from "images/partners/vanda.svg"
import LogoRauma from "images/partners/rauma.svg"
import LogoEspoo from "images/partners/espoo.svg"
import LogoRovaniemi from "images/partners/rovaniemi.svg"
import LogoLaitila from "src/images/partners/laitila.svg"
import LogoVihti from "src/images/partners/vihti.svg"
import LogoOrimattila from "src/images/partners/orimattila.svg"
import LogoNaantali from "src/images/partners/naantali.svg"
import LogoNadendal from "src/images/partners/nadendal.svg"
// import LogoAanekoski from "src/images/partners/aanekoski.svg"
import LogoJanakkala from "src/images/partners/janakkala.svg"
import LogoLempaala from "src/images/partners/lempaala.svg"
import LogoVora from "src/images/partners/vora.svg"
import LogoVoyri from "src/images/partners/voyri.svg"
import LogoUusikaupunki from "src/images/partners/uusikaupunki.svg"
import LogoKankaanpaa from "src/images/partners/kankaanpaa.svg"
import LogoKauniainen from "src/images/partners/kauniainen.svg"
import LogoHollola from "src/images/partners/hollola.svg"
import LogoHeinola from "src/images/partners/heinola.svg"
import LogoSakyla from "src/images/partners/sakyla.svg"
import LogoAccountor from "src/images/partners/accountor.svg"
import LogoTammela from "src/images/partners/tammela.svg"
import LogoEurajoki from "src/images/partners/eurajoki.svg"
import LogoIi from "src/images/partners/ii.svg"
import LogoKirkkonummi from "src/images/partners/kirkkonummi.svg"
import LogoLoppi from "src/images/partners/loppi.svg"
import LogoSiuntio from "src/images/partners/siuntio-logo.svg"
import LogoSuomussalmi from "src/images/partners/suomussalmi-logo.svg"
import LogoSotkamo from "src/images/partners/sotkamo-logo.svg"
import LogoMantsala from "src/images/partners/mantsala-logo.svg"
import LogoKerava from "src/images/partners/kerava-logo.svg"
import LogoKarkkila from "src/images/partners/karkkila-logo.svg"
import LogoKemi from "src/images/partners/kemi.svg"
import LogoUlvila from "src/images/partners/ulvila.svg"
import LogoLapua from "src/images/partners/lapua.svg"
// import LogoLiminka from "src/images/partners/liminka.svg"
import LogoLapinjarvi from "src/images/partners/lapinjarvi.svg"
import LogoLapptrask from "src/images/partners/lapptrask.svg"
import LogoPirkkala from "src/images/partners/pirkkala.svg"
import LogoYlitornio from "src/images/partners/ylitornio.svg"
import LogoSalo from "src/images/partners/salo.svg"
import LogoMantyharju from "src/images/partners/mantyharju.svg"
import LogoKeminmaa from "src/images/partners/keminmaa.svg"
import LogoYpaja from "src/images/partners/ypäjä.svg"
// import LogoOuluUniversityFi from "src/images/partners/oulun-yliopisto.svg"
// import LogoOuluUniversityEn from "src/images/partners/university-of-oulu.svg"
import LogoSodankyla from "src/images/partners/sodankyla.svg"
import LogoRaasepori from "src/images/partners/raasepori.svg"
import LogoKruunupyy from "src/images/partners/kruunupyy.svg"
import LogoMikkeli from "src/images/partners/mikkeli.svg"
import LogoKoneensaatio from "src/images/partners/koneensaatio.svg"
import LogoSalonSeudunAmmattiopisto from "src/images/partners/salon-seudun-ammattiopisto.svg"
import LogoLauttassarenYhteiskoulu from "src/images/partners/lauttassaren-yhteiskoulu.svg"
import LogoAlavus from "src/images/partners/alavus.svg"
import LogoAskola from "src/images/partners/askola.svg"
import LogoMaarianhamina from "src/images/partners/maarianhamina.svg"
import LogoPornainen from "src/images/partners/pornainen.svg"
import LogoBotkyrka from "src/images/partners/botkyrka.svg"
import LogoLekebergsKommun from "src/images/partners/lekebergs-kommun.svg"
// import LogoSverigefinskaSkolan from "src/images/partners/sverigefinska-skolan.svg"
import PlanInternationalLogo from "images/partners/plan-international.svg"
import UnicefLogo from "images/partners/unicef.svg"
import EUFlagLogo from "images/partners/eu-flag.svg"

const EU = { image: EUFlagLogo, name: "European Union", className: "" }
const Plan = {
  image: PlanInternationalLogo,
  name: "Plan International",
  className: "",
}
const Unicef = { image: UnicefLogo, name: "UNICEF", className: "" }

const Accountor = { image: LogoAccountor, name: "Accountor", className: "" }
const Espoo = { image: LogoEspoo, name: "Espoo", className: "" }
const Rovaniemi = { image: LogoRovaniemi, name: "Rovaniemi", className: "" }
const Laitila = { image: LogoLaitila, name: "Laitila", className: "" }
const Vantaa = {
  image: Logo7,
  name: "Vantaa",
  className: "md:w-32 px-4 md:px-0",
}
const Vanda = {
  image: LogoVanda,
  name: "Vanda",
  className: "md:w-32 px-4 md:px-0",
}
const Turku = { image: Logo4, name: "Turku", className: "" }
const Abo = { image: LogoAbo, name: "Turku", className: "" }
const Tampere = { image: Logo8, name: "Tampere", className: "" }
const Rauma = { image: LogoRauma, name: "Rauma", className: "" }
const Vihti = { image: LogoVihti, name: "Vihti", className: "" }
const Orimattila = { image: LogoOrimattila, name: "Orimattila", className: "" }
const Naantali = { image: LogoNaantali, name: "Naantali", className: "" }
const Nadendal = { image: LogoNadendal, name: "Nadendal", className: "" }
const Eurajoki = {
  image: LogoEurajoki,
  name: "Eurajoki",
  className: "",
}
const Janakkala = { image: LogoJanakkala, name: "Janakkala", className: "" }
const Lempäälä = {
  image: LogoLempaala,
  name: "Lempäälä",
  className: "md:w-20 px-4 md:px-0",
}
// const Äänekoski = { image: LogoAanekoski, name: "Äänekoski", className: "" }
const Alavus = { image: LogoAlavus, name: "Alavus", className: "" }
const Alavo = { image: LogoAlavus, name: "Alavus", className: "" }
const Askola = { image: LogoAskola, name: "Askola", className: "" }
const Maarianhamina = {
  image: LogoMaarianhamina,
  name: "Maarianhamina",
  className: "",
}
const Mariehamn = {
  image: LogoMaarianhamina,
  name: "Mariehamn",
  className: "",
}
const Vöyri = { image: LogoVoyri, name: "Vöyri", className: "" }
const Vörä = { image: LogoVora, name: "Vörä", className: "" }
const Kauniainen = { image: LogoKauniainen, name: "Kauniainen", className: "" }
const Grankulla = { image: LogoKauniainen, name: "Grankulla", className: "" }
const Uusikaupunki = {
  image: LogoUusikaupunki,
  name: "Uusikaupunki",
  className: "md:w-40",
}
const Kankaanpää = { image: LogoKankaanpaa, name: "Kankaanpää", className: "" }
const Hollola = { image: LogoHollola, name: "Hollola", className: "" }
const Heinola = { image: LogoHeinola, name: "Heinola", className: "" }
const Säkylä = { image: LogoSakyla, name: "Säkylä", className: "" }
const Tammela = { image: LogoTammela, name: "Tammela", className: "" }
const Ii = { image: LogoIi, name: "Ii", className: "md:w-20 px-4 md:px-0" }
const Kirkkonummi = {
  image: LogoKirkkonummi,
  name: "Kirkkonummi",
  className: "",
}
const RäddaBarnen = { image: Logo5, name: "Rädda Barnen", className: "" }
const Loppi = { image: LogoLoppi, name: "Loppi", className: "" }
const Karkkila = { image: LogoKarkkila, name: "Karkkila", className: "" }
const Kemi = { image: LogoKemi, name: "Kemi", className: "" }
const Kerava = {
  image: LogoKerava,
  name: "Kerava",
  className: "md:w-32 px-4 md:px-0",
}
const Mantsälä = { image: LogoMantsala, name: "Mantsälä", className: "" }
const Siuntio = { image: LogoSiuntio, name: "Siuntio", className: "" }
const Sotkamo = { image: LogoSotkamo, name: "Sotkamo", className: "" }
const Suomussalmi = {
  image: LogoSuomussalmi,
  name: "Suomussalmi",
  className: "",
}
const Ulvila = { image: LogoUlvila, name: "Ulvila", className: "" }
const Lapua = { image: LogoLapua, name: "Lapua", className: "" }
// const Liminka = { image: LogoLiminka, name: "Liminka", className: "" }
const Lapinjarvi = { image: LogoLapinjarvi, name: "Lapinjärvi", className: "" }
const Lapptrask = { image: LogoLapptrask, name: "Lappträsk", className: "" }
const PirkkalaFi = { image: LogoPirkkala, name: "Pirkkala", className: "" }
const PirkkalaSv = { image: LogoPirkkala, name: "Birkala", className: "" }
const Ylitornio = { image: LogoYlitornio, name: "Ylitornio", className: "" }
const Ypaja = { image: LogoYpaja, name: "Ypäjä", className: "" }
const Salo = {
  image: LogoSalo,
  name: "Salo",
  className: "md:w-32 px-4 md:px-0",
}
const Mantyharju = { image: LogoMantyharju, name: "Mäntyharju", className: "" }
const Keminmaa = { image: LogoKeminmaa, name: "Keminmaa", className: "" }

// const OuluUniversityFi = {
//   image: LogoOuluUniversityFi,
//   name: "Oulun Uliopisto",
//   className: "",
// }
// const OuluUniversityEn = {
//   image: LogoOuluUniversityEn,
//   name: "University of Oulu",
//   className: "",
// }
const Sodankyla = {
  image: LogoSodankyla,
  name: "Sodankylä",
  className: "",
}
const Raasepori = {
  image: LogoRaasepori,
  name: "Raasepori",
  className: "",
}
const Raseborg = {
  image: LogoRaasepori,
  name: "Raseborg",
  className: "",
}
const Kruunupyy = {
  image: LogoKruunupyy,
  name: "Kruunupyy",
  className: "",
}
const Kronoby = {
  image: LogoKruunupyy,
  name: "Kronoby",
  className: "",
}
const Mikkeli = {
  image: LogoMikkeli,
  name: "Mikkeli",
  className: "",
}
const StMichel = {
  image: LogoMikkeli,
  name: "StMichel",
  className: "",
}
const Koneensaatio = {
  image: LogoKoneensaatio,
  name: "Koneensaatio",
  className: "",
}
const LauttassarenYhteiskoulu = {
  image: LogoLauttassarenYhteiskoulu,
  name: "Lauttassaren Yhteiskoulu",
  className: "",
}
const SalonSeudunAmmattiopisto = {
  image: LogoSalonSeudunAmmattiopisto,
  name: "Salon Seudun Ammattiopisto",
  className: "",
}
const Pornainen = { image: LogoPornainen, name: "Pornainen", className: "" }
const Borgnäs = { image: LogoPornainen, name: "Borgnäs", className: "" }
const Botkyrka = { image: LogoBotkyrka, name: "Botkyrka kommun", className: "" }
const LekebergsKommun = {
  image: LogoLekebergsKommun,
  name: "Lekebergs kommun",
  className: "",
}
// const SverigefinskaSkolan = {
//   image: LogoSverigefinskaSkolan,
//   name: "Sverigefinska skolan",
//   className: "",
// }

export const citiesFi = [
  Alavus,
  Askola,
  Espoo,
  Eurajoki,
  Heinola,
  Hollola,
  // Ii,
  Janakkala,
  Kankaanpää,
  Karkkila,
  Kauniainen,
  // Kemi,
  Keminmaa,
  Kirkkonummi,
  Kruunupyy,
  // Laitila,
  // Lapinjarvi,
  Lapua,
  LauttassarenYhteiskoulu,
  Lempäälä,
  // Liminka,
  // Loppi,
  Maarianhamina,
  Mantsälä,
  Mantyharju,
  Mikkeli,
  Naantali,
  // OuluUniversityFi,
  PirkkalaFi,
  Pornainen,
  Raasepori,
  Rauma,
  // Rovaniemi,
  // Säkylä,
  Salo,
  // Tammela,
  Sodankyla,
  // Tampere,
  Ulvila,
  // Uusikaupunki,
  Vantaa,
  Vihti,
  // Vöyri,
  Ylitornio,
  Ypaja,
  Kerava,
  SalonSeudunAmmattiopisto,
  Siuntio,
  Sotkamo,
  Suomussalmi,
  // Äänekoski,
]
export const citiesSv = [
  Alavo,
  // Äänekoski,
  Askola,
  Borgnäs,
  Espoo,
  Eurajoki,
  Grankulla,
  Heinola,
  Hollola,
  // Ii,
  Janakkala,
  Kankaanpää,
  Karkkila,
  // Kemi,
  Keminmaa,
  Kirkkonummi,
  Kronoby,
  // Laitila,
  Lapptrask,
  Lapua,
  LauttassarenYhteiskoulu,
  Lempäälä,
  // Liminka,
  // Loppi,
  Mantyharju,
  Mariehamn,
  Nadendal,
  // OuluUniversityEn,
  PirkkalaSv,
  Raseborg,
  Rauma,
  // Rovaniemi,
  // Säkylä,
  Salo,
  SalonSeudunAmmattiopisto,
  // Tammela,
  Sodankyla,
  // Tampere,
  Ulvila,
  // Uusikaupunki,
  Vanda,
  Vihti,
  // Vörä,
  Ylitornio,
  Ypaja,
  Kerava,
  Mantsälä,
  Siuntio,
  Sotkamo,
  StMichel,
  Suomussalmi,
]
const logosFiFiWithCompanies = citiesFi.concat(Accountor, Koneensaatio)
const logosSvFiWithCompanies = citiesSv.concat(Accountor, Koneensaatio)
// Everything after the Swedish block is Finnish: Accountor and Rädda Barnen are
// Finnish organisations, and `citiesSv` is Finnish municipalities under their
// Swedish names. New Sweden-based partners belong in the first group.
const logosSvSeWithCompanies = [
  // Sweden-based
  Botkyrka,
  LekebergsKommun,
  // SverigefinskaSkolan,
  // then the rest
  Accountor,
  RäddaBarnen,
].concat(citiesSv)
const logosEnGlobalWithCompanies = [EU, Plan, Unicef].concat(citiesFi)

export const logosByLocale = {
  "fi-fi": logosFiFiWithCompanies,
  "sv-fi": logosSvFiWithCompanies,
  "sv-se": logosSvSeWithCompanies,
  "en-fi": logosFiFiWithCompanies,
  "en-us": logosEnGlobalWithCompanies,
}

export const customLogosByPage = {
  "/schools/onboarding": {
    "fi-fi": citiesFi,
    "sv-fi": citiesSv,
    "en-fi": citiesFi,
  },
}
